import React from 'react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import useLanguage from '../../../../hooks/useLanguage';
import PropTypes from 'prop-types';
import Quote from '../../../UiComponents/Quote/Quote';

const AboutFounder = ({ founderData }) => {
  const langToggle = useLanguage;
  const image = getImage(founderData.about_founder.image.localFile);

  return (
    <>
      <section className="about-founder" data-scroll-section>
        <div className="content-wrapper">
          <div className="default-info__header">
            <span className="default-info__header-marker">
              {langToggle(founderData.marker_ua, founderData.marker_ru)}
            </span>
            <h2 className="default-info__header-title">
              {langToggle(founderData.title_ua, founderData.title_ru)}
            </h2>
          </div>
          <div className="founder-wrapper">
            <div className="founder-image__wrapper">
              <div
                className="founder-image__overflow"
                data-scroll=""
                data-scroll-speed="-1"
              >
                 <GatsbyImage
                    image={image}
                    className="founder-image"
                    alt= {langToggle(founderData.about_founder.marker_ua, founderData.about_founder.marker_ru)}
                  />
              </div>
            </div>
            <div className="founder-info__wrapper">
              <span className="founder-info__marker">
                {langToggle(
                  founderData.about_founder.marker_ua,
                  founderData.about_founder.marker_ru
                )}
              </span>
              <h3 className="founder-info__title">
                {' '}
                {langToggle(
                  founderData.about_founder.title_ua,
                  founderData.about_founder.title_ru
                )}
              </h3>
              <p className="founder-info__description">
                {langToggle(
                  founderData.about_founder.description_ua,
                  founderData.about_founder.description_ru
                )}
              </p>
            </div>
          </div>
        </div>
      </section>
      <Quote quoteData={founderData} />
      <section className="founder-additional" data-scroll-section>
        <div className="content-wrapper">
          <div className="founder-additional__wrapper">
            <div className="founder-additional__item">
              <span className="additional__item-marker">
                {langToggle(
                  founderData.history_marker_ua,
                  founderData.history_marker_ru
                )}
              </span>
              <p className="additional__item-description">
                {langToggle(founderData.history_ua, founderData.history_ru)}
              </p>
            </div>
            <div className="founder-additional__item">
              <span className="additional__item-marker">
                {langToggle(
                  founderData.approach_marker_ua,
                  founderData.approach_marker_ru
                )}
              </span>
              <p className="additional__item-description">
                {langToggle(founderData.approach_ua, founderData.approach_ru)}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

AboutFounder.propTypes = {
  founderData: PropTypes.object,
};

export default AboutFounder;
